export default __webpack_public_path__ + "static/media/try-atomic-transport-form.dcca1136.png";